// Font Awesome Icon Configuration
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faTrashAlt, 
  faPencilAlt, 
  faPlus, 
  faSave, 
  faBan, 
  faBars,
  faCog,
  faChevronLeft,
  faArrowLeft,
  faHandScissors,
  faPrint,
  faSearch,
  faStethoscope,
  faFilePdf
} from '@fortawesome/free-solid-svg-icons';

// Register all icons used throughout the application
library.add(
  faTrashAlt,     // Used for delete buttons
  faPencilAlt,    // Used for edit buttons
  faPlus,         // Used for add buttons
  faSave,         // Used for save buttons
  faBan,          // Used for cancel buttons
  faBars,         // Used for the sidebar toggle
  faCog,          // Used for the settings button
  faChevronLeft,  // Used for back buttons
  faArrowLeft,    // Used for navigation
  faHandScissors, // Used for splitting appointments
  faPrint,        // Used for printing
  faSearch,       // Used for search functionality
  faStethoscope,  // Used in the settings for doctor list
  faFilePdf       // Used in the settings for reports
);

// You can add more icons as needed by importing them above and adding them to library.add()